"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardUniversal = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const clsx_1 = __importDefault(require("clsx"));
const lodash_1 = require("lodash");
const Card_1 = __importDefault(require("@material-ui/core/Card"));
const CardContent_1 = __importDefault(require("@material-ui/core/CardContent"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const Box_1 = __importDefault(require("@material-ui/core/Box"));
const IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
const Settings_1 = __importDefault(require("@material-ui/icons/Settings"));
const Refresh_1 = __importDefault(require("@material-ui/icons/Refresh"));
const Close_1 = __importDefault(require("@material-ui/icons/Close"));
const event_callback_hook_1 = require("../../../../utils/event-callback-hook");
const reporting_context_1 = require("../../../reporting/reporting-context");
const dashboard_context_1 = require("../../dashboard-context");
const card_action_1 = require("../action/card-action");
const card_styles_1 = require("../card-styles");
const card_settings_dialog_1 = require("./card-settings-dialog");
function CardUniversal({ report, load, loading, definitionId, }) {
    var _a, _b;
    const intl = react_intl_1.useIntl();
    const classes = card_styles_1.useStyles();
    const { generate } = react_1.useContext(reporting_context_1.ReportingContext);
    const { definitions, remove, classes: classesOverride } = react_1.useContext(dashboard_context_1.DashboardContext);
    const settingsDialogRef = react_1.useRef(null);
    const definition = definitions.find((d) => d.id === definitionId);
    const handleRemove = event_callback_hook_1.useEventCallback(() => {
        remove(definitionId);
    });
    const handleOpenSettingsDialog = event_callback_hook_1.useEventCallback(() => {
        var _a;
        (_a = settingsDialogRef.current) === null || _a === void 0 ? void 0 : _a.open();
    });
    const handleRefresh = event_callback_hook_1.useEventCallback(async () => {
        await generate(definitionId, report === null || report === void 0 ? void 0 : report.configuration);
        await load();
    });
    let title;
    let value;
    let showActions;
    if (definition === undefined) {
        title = intl.formatMessage({
            id: 'EAS_DASHBOARD_CARD_UNIVERSAL_MSG_ERROR',
            defaultMessage: 'Chyba reportu',
        });
        value = '';
        showActions = false;
    }
    else if (loading) {
        title = intl.formatMessage({
            id: 'EAS_DASHBOARD_CARD_UNIVERSAL_MSG_LOADING',
            defaultMessage: 'Načtení údajů',
        });
        value = '';
        showActions = false;
    }
    else if (report === undefined) {
        title = definition.groupLabel;
        value = definition.label;
        showActions = false;
    }
    else if ((report === null || report === void 0 ? void 0 : report.columns.length) !== 2) {
        title = intl.formatMessage({
            id: 'EAS_DASHBOARD_CARD_UNIVERSAL_MSG_UNSUPPORTED',
            defaultMessage: 'Nepodporovaný report',
        });
        value = '';
        showActions = false;
    }
    else {
        title = definition.groupLabel;
        value = definition.label;
        showActions = true;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Card_1.default, { variant: "outlined", className: clsx_1.default(classes.card, classes.cardUniversal, classesOverride === null || classesOverride === void 0 ? void 0 : classesOverride.card) },
            react_1.default.createElement(Box_1.default, { className: classes.cardRemove },
                react_1.default.createElement(IconButton_1.default, { size: "small", className: classes.cardRemoveButton, "aria-label": intl.formatMessage({
                        id: 'EAS_DASHBOARD_CARD_UNIVERSAL_REMOVE_BTN_ARIA',
                        defaultMessage: 'Odstranit',
                    }), onClick: handleRemove },
                    react_1.default.createElement(Close_1.default, { fontSize: 'small' }))),
            react_1.default.createElement(Box_1.default, { className: classes.cardUniversalMenu },
                ((_b = (_a = definition === null || definition === void 0 ? void 0 : definition.inputFields) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0 && (react_1.default.createElement(IconButton_1.default, { "aria-label": intl.formatMessage({
                        id: 'EAS_DASHBOARD_CARD_UNIVERSAL_SETTINGS_BTN_ARIA',
                        defaultMessage: 'Nastavení',
                    }), onClick: handleOpenSettingsDialog },
                    react_1.default.createElement(Settings_1.default, null))),
                (definition === null || definition === void 0 ? void 0 : definition.autogenerate) === false && (react_1.default.createElement(IconButton_1.default, { "aria-label": intl.formatMessage({
                        id: 'EAS_DASHBOARD_CARD_UNIVERSAL_REFRESH_BTN_ARIA',
                        defaultMessage: 'Obnova',
                    }), onClick: handleRefresh },
                    react_1.default.createElement(Refresh_1.default, null)))),
            react_1.default.createElement(CardContent_1.default, { className: classes.cardUniversalContent },
                react_1.default.createElement(Typography_1.default, { className: clsx_1.default(classes.cardUniversalTitle, classesOverride === null || classesOverride === void 0 ? void 0 : classesOverride.cardUniversalTitle) }, title),
                react_1.default.createElement(Typography_1.default, { className: clsx_1.default(classes.cardUniversalValue, classesOverride === null || classesOverride === void 0 ? void 0 : classesOverride.cardUniversalValue) }, value))),
        report !== undefined && definition !== undefined && (react_1.default.createElement(card_settings_dialog_1.CardSettingsDialog, { ref: settingsDialogRef, report: report, definition: definition, load: load })),
        react_1.default.createElement(Card_1.default, { className: classes.cardActions, variant: "outlined" }, showActions && (report === null || report === void 0 ? void 0 : report.data.map((item, i) => (react_1.default.createElement(card_action_1.CardAction, { key: i, title: lodash_1.get(item, report.columns[0].datakey), value: lodash_1.get(item, report.columns[1].datakey) })))))));
}
exports.CardUniversal = CardUniversal;
//# sourceMappingURL=card-universal.js.map